









import {Vue, Component, Model, Prop} from 'vue-property-decorator';

export interface CompSelectBoxOption<ValueType> {
  name: string;
  value: ValueType;
}

@Component
export default class CompSelectBox extends Vue {
  @Prop({default: '전체'}) private needAllText!: string;
  @Prop({default: false}) private needAll!: boolean;
  @Prop({required: false}) private needAllValue: any;
  @Prop({default: false}) private nonI18nConvert!: boolean;
  @Prop({required: true}) private data!: object;
  @Prop({default: 'value'})
  private selectValue!: string | number;
  @Prop({default: 'value'})
  private selectKey!: string | number;
  @Prop({default: 'name'})
  private selectDisplayName!: string;
  @Prop({default: 'disabledV', required: false})
  private disableOption!: string;
  @Prop({default: false, required: false})
  private disabled!: boolean;

  @Model('change') readonly value!: any;
  get selectedValue() {
    return this.value;
  }
  set selectedValue(val) {
    this.$emit('change', val, this.value);
  }
  public focus() {
    (this.$refs.select as any).focus();
  }
}
